import { Modal } from '@eventbrite/eds-modal';
import { ProgressIndicator } from '@eventbrite/eds-progress-indicator';
import React, { useEffect, useState } from 'react';
import { sendSoftAccountEmailAction } from '../../actions/emails';
import SoftAccountStatusContent from '../../components/SoftAccountStatusContent';
import { SOFT_ACCOUNT_EMAIL_STATUSES } from '../../constants/status';
import {
    IConfigContextProps,
    useConfigContext,
} from '../../contexts/ConfigContext';
import {
    IFrontendContext,
    MODAL_TYPES,
    useFrontendContext,
} from '../../contexts/FrontendContext';
import {
    INotificationContext,
    useNotificationsContext,
} from '../../contexts/NotificationsContext';
import { IUserContext, useUserContext } from '../../contexts/UserContext';

const loadingState = (
    <div className="eds-l-pad-all-8 eds-align--center">
        <ProgressIndicator
            size="large-chunky"
            shape="circular"
            style="gradient"
        />
    </div>
);

const SoftAccountSection = ({ dataTestId = 'soft-account-modal' }) => {
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [modalBody, setModalBody] = useState(loadingState);

    const frontendContext: IFrontendContext = useFrontendContext();
    const userContext: IUserContext = useUserContext();
    const notificationsContext: INotificationContext =
        useNotificationsContext();
    const configContext: IConfigContextProps = useConfigContext();

    useEffect(() => {
        sendSoftAccountEmailAction({
            contexts: {
                configContext,
                frontendContext,
                notificationsContext,
                userContext,
            },
        });
        setIsModalOpen(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (
            frontendContext.state.softAccountEmailStatus ===
                SOFT_ACCOUNT_EMAIL_STATUSES.delivered ||
            frontendContext.state.softAccountEmailStatus ===
                SOFT_ACCOUNT_EMAIL_STATUSES.failed
        ) {
            setModalBody(<SoftAccountStatusContent />);
        } else {
            setModalBody(loadingState);
        }
    }, [frontendContext.state.softAccountEmailStatus]);

    return (
        <div data-testid={dataTestId}>
            <Modal
                noMinHeight={true}
                modalBodyIsEmpty={true}
                isShown={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false);
                    setModalBody(loadingState);

                    frontendContext.methods.setShowModal(MODAL_TYPES.closed);
                }}
            >
                {modalBody}
            </Modal>
        </div>
    );
};

export default SoftAccountSection;
